import { loadScript } from "./script";

type StopProc = () => void;

interface RRWebRecordOptions {
  emit: (event: any) => void;
  sampling?: {
    mousemove?: boolean;
    mouseInteraction?: boolean;
    scroll?: number;
    media?: number;
    input?: "last";
  };
}

type RRWebRecord = (options: RRWebRecordOptions) => StopProc;
interface RRWeb {
  record: RRWebRecord;
}

const getRRWeb = async (): Promise<RRWeb> => {
  if (!("rrwebRecord" in window)) {
    await loadScript(
      "https://cdn.jsdelivr.net/npm/rrweb@2.0.0-alpha.4/dist/record/rrweb-record.min.js",
    );
  }
  return {
    record: (window as any).rrwebRecord as RRWebRecord,
  };
};

export class RRWebRecorder {
  private rrweb: Promise<RRWeb>;

  constructor() {
    this.rrweb = getRRWeb();
  }

  async record(emit: (data: Record<string, any>) => void): Promise<StopProc> {
    return (await this.rrweb).record({
      emit: (event) => emit(event),
      sampling: {
        mousemove: false,
        mouseInteraction: true,
        scroll: 150,
        media: 500,
        input: "last",
      },
    });
  }
}
